<template>
  <div v-if="false" class="tll-container" data-component="teacher-literature-library">
    <!-- Header Section -->
    <div class="tll-header">
      <h1 class="tll-header__title">Ваша литература</h1>
      
      <!-- Search Bar -->
      <div class="tll-search">
        <div class="tll-search__bg" />
        <img
          class="tll-search__icon"
          alt="Поиск"
          src="/assets/animaapp/vector.svg"
        />
        <div class="tll-search__placeholder">Поиск</div>
      </div>

      <!-- Add Material Button -->
      <div class="tll-add-btn">
        <div class="tll-add-btn__bg" />
        <div class="tll-add-btn__text">Добавить материал +</div>
      </div>

      <!-- Navigation Arrows -->
      <div class="tll-nav">
        <div class="tll-nav__btn tll-nav__btn--prev">
          <img
            class="tll-nav__btn-bg"
            alt="Предыдущая страница"
            src="/assets/animaapp/rectangle-87.svg"
          />
            <!-- Стрелка влево -->
            <div class="tll-nav__btn-icon">
                <svg width="10" height="16" view="0 0 10 16" fill="none">
                    <path d="M0.453125 7.20312L6.82812 0.828125C7.29688 0.40625 8 0.40625 8.42188 0.828125L9.5 1.90625C9.92188 2.32812 9.92188 3.07812 9.5 3.5L4.95312 8L9.5 12.5469C9.92188 12.9688 9.92188 13.6719 9.5 14.1406L8.42188 15.1719C8 15.6406 7.29688 15.6406 6.82812 15.1719L0.453125 8.79688C0.03125 8.375 0.03125 7.67188 0.453125 7.20312Z" fill="currentColor"/>
                </svg>
            </div>
        </div>
        <div class="tll-nav__btn tll-nav__btn--next">
          <img
            class="tll-nav__btn-bg"
            alt="Следующая страница"
            src="/assets/animaapp/rectangle-86.svg"
          />
          <!-- Стрелка вправо -->
<div class="tll-nav__btn-icon">
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
        <path d="M9.5 8.79688L3.125 15.1719C2.65625 15.6406 1.95312 15.6406 1.53125 15.1719L0.453125 14.1406C0.03125 13.6719 0.03125 12.9688 0.453125 12.5469L5 8.04688L0.453125 3.5C0.03125 3.07812 0.03125 2.375 0.453125 1.90625L1.53125 0.828125C1.95312 0.40625 2.65625 0.40625 3.125 0.828125L9.5 7.20312C9.92188 7.67188 9.92188 8.375 9.5 8.79688Z" fill="currentColor"/>
    </svg>
</div>
        </div>
      </div>
    </div>

    <!-- Content Section -->
    <div class="tll-content">
      <!-- First Row of Cards -->
      <div class="tll-cards-row">
        <!-- Card 1 -->
        <article class="tll-card tll-card--pos-1">
          <div class="tll-card__inner tll-card__inner--w427">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-14.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------7@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v1"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-198-1@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>

        <!-- Card 2 -->
        <article class="tll-card tll-card--pos-2">
          <div class="tll-card__inner tll-card__inner--w428">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-10.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------5@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v2"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-197-1@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>

        <!-- Card 3 -->
        <article class="tll-card tll-card--pos-3">
          <div class="tll-card__inner tll-card__inner--w428">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-14.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------7@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v3"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-197-2@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>

        <!-- Card 4 -->
        <article class="tll-card tll-card--pos-4">
          <div class="tll-card__inner tll-card__inner--w428">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-14.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------7@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v3"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-196-1@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>
      </div>

      <!-- Second Row of Cards -->
      <div class="tll-cards-row">
        <!-- Card 5 -->
        <article class="tll-card tll-card--pos-1">
          <div class="tll-card__inner tll-card__inner--w428">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-14.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------7@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v3"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-196-1@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>

        <!-- Card 6 -->
        <article class="tll-card tll-card--pos-2">
          <div class="tll-card__inner tll-card__inner--w428">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-14.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------7@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v3"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-197-2@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>

        <!-- Card 7 -->
        <article class="tll-card tll-card--pos-3">
          <div class="tll-card__inner tll-card__inner--w428">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-14.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------7@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v1"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-198-1@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>

        <!-- Card 8 -->
        <article class="tll-card tll-card--pos-4">
          <div class="tll-card__inner tll-card__inner--w428">
            <div class="tll-card__category">
              <div class="tll-card__category-bg" />
              <img
                class="tll-card__category-icon"
                alt="Иконка категории"
                src="/assets/animaapp/vector-14.svg"
              />
              <div class="tll-card__category-text">Управление</div>
            </div>
            <div class="tll-card__rating">
              <img
                class="tll-card__rating-stars"
                alt="Звезды рейтинга"
                src="/assets/animaapp/-------7@2x.png"
              />
              <div class="tll-card__rating-value">4,5</div>
              <div class="tll-card__rating-reviews">(25 отзывов)</div>
            </div>
            <div class="tll-card__meta">
              <div class="tll-card__downloads">Скачали: 120</div>
              <div class="tll-card__category-label">Категория: Продажи</div>
            </div>
            <h3 class="tll-card__title">Управление производством</h3>
            <img
              class="tll-card__image tll-card__image--v3"
              alt="Обложка: Управление производством"
              src="/assets/animaapp/rectangle-199@2x.png"
            />
          </div>
          <button class="tll-card__hide-btn" type="button">
            <span class="tll-card__hide-text">Скрыть</span>
            <img
              class="tll-card__hide-icon"
              alt=""
              src="/assets/animaapp/vector-15.svg"
            />
          </button>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeacherLiteratureLibrary",
};
</script>

<style scoped>
/* ============================================
   MAIN CONTAINER
   ============================================ */
.tll-container {
  position: relative;
  width: 1382px;
  left: 45px;
}

/* ============================================
   HEADER SECTION
   ============================================ */
.tll-header {
  height: 38px;
  position: relative;
  width: 100%;
  margin-bottom: 40px;
}

/* Header Title */
.tll-header__title {
  color: #000000;
  font-family: "Poppins", Helvetica;
  font-size: 25px;
  font-weight: 700;
  left: 0;
  letter-spacing: 0;
  line-height: normal;
  margin: 0;
  position: absolute;
  top: 0;
}

/* ============================================
   SEARCH BAR
   ============================================ */
.tll-search {
  height: 30px;
  left: 272px;
  position: absolute;
  top: 4px;
  width: 329px;
}

.tll-search__bg {
  background-color: #7e7e7e33;
  border-radius: 12px;
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 327px;
}

.tll-search__icon {
  aspect-ratio: 1;
  height: 15px;
  left: 27px;
  position: absolute;
  top: 9px;
  width: 15px;
}

.tll-search__placeholder {
  color: #00000080;
  font-family: "Poppins", Helvetica;
  font-size: 15px;
  font-weight: 400;
  left: 50px;
  letter-spacing: 0.60px;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 8px;
}

/* ============================================
   ADD MATERIAL BUTTON
   ============================================ */
.tll-add-btn {
  height: 35px;
  left: 679px;
  position: absolute;
  top: 2px;
  width: 202px;
  cursor: pointer;
}


.tll-add-btn__bg {
  background-color: #0095ec;
  border-radius: 10px;
  height: 35px;
  left: 0;
  position: absolute;
  top: 0;
  width: 200px;
}

.tll-add-btn__text {
  color: #ffffff;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  font-weight: 600;
  left: 17px;
  letter-spacing: 0.28px;
  line-height: normal;
  position: absolute;
  top: 10px;
}

/* ============================================
   NAVIGATION ARROWS
   ============================================ */
.tll-nav {
  display: flex;
  gap: 10px;
  height: 30px;
  left: 972px;
  position: absolute;
  top: 4px;
  width: 72px;
}

.tll-nav__btn {
  height: 30px;
  position: relative;
  width: 32px;
}

.tll-nav__btn-bg {
  aspect-ratio: 1;
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 30px;
  cursor: pointer;
	transition: transform 0.2s ease;
}

.tll-nav__btn-bg:hover{
	transform: scale(1.1);
}

.tll-nav__btn-icon {
  position: absolute;
    left: 11px;
    top: 6px;
    width: 10px;
    height: 16px;
    color: #ffffff;
}

/* ============================================
   CONTENT SECTION
   ============================================ */
.tll-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-height: 931px;
  position: relative;
  width: 1276px;
}

/* ============================================
   CARDS ROW
   ============================================ */
.tll-cards-row {
  height: 458px;
  position: relative;
  width: 1276px;
}

/* ============================================
   CARD COMPONENT
   ============================================ */
.tll-card {
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 18.83px 47.08px #2f327d1a;
  height: 304px;
  position: absolute;
  top: 77px;
  transform: rotate(-90deg);
  width: 458px;
}

/* Card Position Variants */
.tll-card--pos-1 {
  left: 895px;
}

.tll-card--pos-2 {
  left: 571px;
}

.tll-card--pos-3 {
  left: 247px;
}

.tll-card--pos-4 {
  left: -77px;
}

/* Card Inner Container */
.tll-card__inner {
  height: 263px;
  left: 13px;
  position: absolute;
  top: 22px;
}

.tll-card__inner--w427 {
  width: 427px;
}

.tll-card__inner--w428 {
  width: 428px;
}

/* ============================================
   CARD CATEGORY BADGE
   ============================================ */
.tll-card__category {
  height: 30px;
  left: -48px;
  position: absolute;
  top: 186px;
  transform: rotate(90deg);
  width: 127px;
}

.tll-card__category-bg {
  background-color: #0095eccc;
  border-radius: 15px;
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 125px;
}

.tll-card__category-icon {
  aspect-ratio: 1;
  height: 10px;
  left: 9.45%;
  position: absolute;
  top: calc(50.00% - 5px);
  width: 7.87%;
}

.tll-card__category-text {
  color: #ffffff;
  font-family: "Poppins", Helvetica;
  font-size: 13px;
  font-weight: 700;
  left: calc(50.00% - 35px);
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50.00% - 10px);
}

/* ============================================
   CARD RATING
   ============================================ */
.tll-card__rating {
  height: 25px;
  left: -70px;
  position: absolute;
  top: 118px;
  transform: rotate(90deg);
  width: 263px;
}

.tll-card__rating-stars {
  height: 88.00%;
  left: 0;
  position: absolute;
  top: 0;
  width: 48.67%;
}

.tll-card__rating-value {
  color: #636363;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  font-weight: 400;
  left: 135px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.tll-card__rating-reviews {
  color: #636363;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  font-weight: 400;
  left: 165px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

/* ============================================
   CARD META INFO
   ============================================ */
.tll-card__meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  height: 147px;
  left: 84px;
  position: absolute;
  top: 0;
  width: 57px;
}

.tll-card__downloads {
  color: #00000080;
  font-family: "Poppins", Helvetica;
  font-size: 15px;
  font-weight: 400;
  height: 23px;
  letter-spacing: 0.30px;
  line-height: normal;
  margin-left: -36.5px;
  margin-top: 36.5px;
  transform: rotate(90deg);
  width: 96px;
}

.tll-card__category-label {
  color: #636363;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  font-weight: 400;
  height: 25px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  margin-left: -32.5px;
  transform: rotate(90deg);
  white-space: nowrap;
  width: 146px;
}

/* ============================================
   CARD TITLE
   ============================================ */
.tll-card__title {
  color: #000000cc;
  font-family: "Poppins", Helvetica;
  font-size: 17px;
  font-weight: 600;
  left: 28px;
  letter-spacing: 0.34px;
  line-height: normal;
  margin: 0;
  position: absolute;
  top: 118px;
  transform: rotate(90deg);
}

/* ============================================
   CARD IMAGE
   ============================================ */
.tll-card__image {
  height: 251px;
  object-fit: cover;
  position: absolute;
  transform: rotate(90deg);
  width: 236px;
}

.tll-card__image--v1 {
  left: 182px;
  top: 6px;
}

.tll-card__image--v2 {
  left: 183px;
  top: 4px;
}

.tll-card__image--v3 {
  left: 182px;
  top: 4px;
}

/* ============================================
   CARD HIDE BUTTON
   ============================================ */
.tll-card__hide-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  height: 21px;
  left: -17px;
  padding: 0;
  position: absolute;
  top: 52px;
  transform: rotate(90deg);
  width: 83px;
}

.tll-card__hide-text {
  color: #00000099;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  font-weight: 600;
  left: 0;
  letter-spacing: 0.28px;
  line-height: normal;
  position: absolute;
  top: 0;
}

.tll-card__hide-icon {
  aspect-ratio: 1.5;
  height: 11px;
  left: 77.34%;
  position: absolute;
  top: calc(50.00% - 6px);
  width: 20.24%;
}
</style>